document.addEventListener("DOMContentLoaded", function () {
    let accordionButtons = document.querySelectorAll(".button-accordion");

    accordionButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
            let target = document.querySelector(button.getAttribute("data-bs-target"));

            // Sauvegarde la position actuelle AVANT le changement d'état
            let previousScrollY = window.scrollY;

            setTimeout(() => {
                let rect = target.getBoundingClientRect();

                // Vérifie que l'accordéon est bien en train de s'ouvrir et qu'il dépasse l'écran
                if (target.classList.contains("show") && rect.bottom > window.innerHeight) {
                    let newScrollY = previousScrollY + rect.top - 100; // Ajuste la position
                    window.scrollTo({
                        top: newScrollY,
                        behavior: "smooth"
                    });
                }
            }, 350); // Délai pour laisser le temps à l'animation Bootstrap
        });
    });

    // Empêcher le saut de page lors de la fermeture d'un accordéon
    let accordionItems = document.querySelectorAll(".accordion-collapse");

    accordionItems.forEach((item) => {
        item.addEventListener("hide.bs.collapse", function () {
            let currentScrollY = window.scrollY;
            setTimeout(() => {
                window.scrollTo({ top: currentScrollY, behavior: "instant" });
            }, 50);
        });
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })
});